export default {
  "Cut Audio": "Audio ausschneiden",
  "HitPaw Online Audio Cutter": "HitPaw Online Audio Cutter",
  "Trim or cut any audio files online.": "Trimmen oder schneiden Audiodateien Online.",
  "Cut": "Ausschneiden",
  "Fade in": "Einblenden",
  "Fade out": "Ausblenden",
  "Cut from": "Von schneiden",
  "to": "zu",
  "Extract selection": "Auswahl extrahieren",
  "Delete selection": "Auswahl löschen",
  "Adjust New": "Neu anpassen",
  "Cut New": "Neu ausschneiden",
  "Adjust Volume": "Lautstärke anpassen",
  "HitPaw Online Volume Changer": "HitPaw Online Lautstärkewechsler",
  "Turn up or Turn down the volume of audio.": "Erhöhen oder verringern die Lautstärke des Audios.",
  "Volume": "Lautstärke",
  "Change Speed": "Geschwindigkeit ändern",
  "HitPaw Online Audio Speed Changer": "HitPaw Online Audio Geschwindigkeitswechsler",
  "Speed up or slow down audios online easily.": "Beschleunigen oder verlangsamen Audios Online ganz einfach.",
  "Speed": "Geschwindigkeit",
  "Format": "Format",
  "Size": "Größe",
  "Duration": "Dauer",
};
